import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import CloudDisk_001 from './img/CloudDisk_001.png'
import CloudDisk_002 from './img/CloudDisk_002.png'
import CloudDisk_003 from './img/CloudDisk_003.png'
import CloudDisk_004 from './img/CloudDisk_004.png'

export default class CloudDisk extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">个人云盘</div>
        <img src={CloudDisk_001} className="main-window-img"></img>
        <img src={CloudDisk_002} className="main-window-img"></img>
        <img src={CloudDisk_003} className="main-window-img"></img>
        <img src={CloudDisk_004} className="main-window-img"></img>
      </div>
    )
  }
}
